import { authRoles } from 'app/auth';
import FejezetTable from 'app/admin/fejezet/table/FejezetTable';
import FejezetEditForm from 'app/admin/fejezet/editform/FejezetEditForm';

export default [
	{
		path: '/fejezet/edit/:id',
		component: FejezetEditForm,
		auth: authRoles.admin
	},
	{
		path: '/fejezet/:sessionNameParam?',
		component: FejezetTable,
		auth: authRoles.admin
	}
];
